var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-preview m-container-max"},[(_vm.isPC)?_c('div',{staticClass:"x-qrcode"},[_vm._m(0),_c('div',{attrs:{"id":"qrcode"}})]):_vm._e(),_c('ArticleTemplate',{attrs:{"article-detail":_vm.articleDetail}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-text"},[_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v("美信扫码预览文章")])])
}]

export { render, staticRenderFns }